import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ama_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    // Normalise Pydantic-style array errors to a readable Italian string
    const raw = err?.response?.data?.detail;
    if (Array.isArray(raw)) {
      err.response.data.detail = raw
        .map((x) => (typeof x === "object" && x?.msg ? x.msg : String(x)))
        .join("; ");
    } else if (raw && typeof raw === "object") {
      err.response.data.detail = raw.msg || raw.message || "Errore";
    }
    if (err?.response?.status === 401 && !err.config?.url?.includes("/auth/login")) {
      localStorage.removeItem("ama_token");
      localStorage.removeItem("ama_user");
      if (!window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/approvazione")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;

export const STATUS_LABELS = {
  Bozza: "Bozza",
  Ricevuto_da_AMA: "Ricevuto da AMA",
  In_verifica_iniziale: "In verifica iniziale",
  In_attesa_documenti: "In attesa documenti",
  Verifica_garanzia: "Verifica garanzia",
  Pronto_per_la_spedizione: "Pronto per la spedizione",
  Spedito_al_produttore: "Spedito al produttore",
  Consegnato_al_produttore: "Consegnato al produttore",
  In_attesa_di_diagnosi: "In attesa di diagnosi",
  Diagnosi_ricevuta: "Diagnosi ricevuta",
  Preventivo_ricevuto: "Preventivo ricevuto",
  In_attesa_autorizzazione_cliente: "In attesa autorizzazione cliente",
  Autorizzato_dal_cliente: "Autorizzato dal cliente",
  Non_autorizzato_dal_cliente: "Non autorizzato dal cliente",
  Riparazione_in_corso: "Riparazione in corso",
  Riparato: "Riparato",
  Sostituito_in_garanzia: "Sostituito in garanzia",
  Sostituito_fuori_garanzia: "Sostituito fuori garanzia",
  Non_riparabile: "Non riparabile",
  Reso_senza_riparazione: "Reso senza riparazione",
  Nota_di_credito_o_rimborso: "Nota di credito o rimborso",
  In_spedizione_di_rientro: "In spedizione di rientro",
  Rientrato_presso_AMA: "Rientrato presso AMA",
  In_verifica_dopo_il_rientro: "In verifica dopo il rientro",
  Pronto_per_il_ritiro: "Pronto per il ritiro",
  Consegnato_al_cliente: "Consegnato al cliente",
  Chiuso: "Chiuso",
  Annullato: "Annullato",
};

export const STATUS_TONE = {
  Bozza: "neutral",
  Ricevuto_da_AMA: "brand",
  In_verifica_iniziale: "info",
  In_attesa_documenti: "warning",
  Verifica_garanzia: "info",
  Pronto_per_la_spedizione: "info",
  Spedito_al_produttore: "info",
  Consegnato_al_produttore: "info",
  In_attesa_di_diagnosi: "warning",
  Diagnosi_ricevuta: "info",
  Preventivo_ricevuto: "warning",
  In_attesa_autorizzazione_cliente: "warning",
  Autorizzato_dal_cliente: "success",
  Non_autorizzato_dal_cliente: "error",
  Riparazione_in_corso: "info",
  Riparato: "success",
  Sostituito_in_garanzia: "success",
  Sostituito_fuori_garanzia: "success",
  Non_riparabile: "error",
  Reso_senza_riparazione: "warning",
  Nota_di_credito_o_rimborso: "warning",
  In_spedizione_di_rientro: "info",
  Rientrato_presso_AMA: "info",
  In_verifica_dopo_il_rientro: "info",
  Pronto_per_il_ritiro: "success",
  Consegnato_al_cliente: "success",
  Chiuso: "neutral",
  Annullato: "error",
};

export function formatDateIT(iso) {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return d.toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
}

export function formatDateShortIT(iso) {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch { return iso; }
}
